export default () => ({
  globalSettings: null,
});
